import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { computed, defineComponent, inject, nextTick, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import { isEmpty, uniqueId } from "lodash";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { streetTypeAbrvs } from "@Shared/utils/constants";
export default defineComponent({
  name: "AutocompleteInput",
  components: {
    VueGoogleAutocomplete
  },
  props: {
    id: {
      type: String,
      default: () => uniqueId("automcomplete")
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    companyAddress: {
      type: Boolean,
      default: false
    },
    rawValue: {
      type: null,
      default: ""
    },
    clearAfter: {
      type: Boolean,
      default: true
    },
    holdInputValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const valueSetOnMounted = ref(false);
    const vueAutocompleteRef = ref();
    const internalAddressObject = ref({
      line1: "",
      line2: "",
      province: "",
      "postal-code": "",
      "street-direction": "",
      "street-name": "",
      "street-number": "",
      "unit-number": "",
      postal_code: "",
      "street-type": "",
      company: "",
      city: ""
    });
    const DIRECTIONS = ["east", "north", "west", "south", "northwest", "southwest", "northeast", "southeast", "n", "s", "e", "w"];
    const clearAfterAutocomplete = computed(() => props.clearAfter);
    const holdValueAfterAutocomplete = computed(() => props.companyAddress || props.holdInputValue);
    const {
      rawValue
    } = toRefs(props);
    watch(rawValue, val => {
      if (!holdValueAfterAutocomplete.value) return;
      vueAutocompleteRef.value.update(val);
    });
    onMounted(() => {
      if (!holdValueAfterAutocomplete.value) return;
      if (rawValue.value) {
        valueSetOnMounted.value = true;
        vueAutocompleteRef.value.update(rawValue.value);
      }
    });
    const splitAddress = routeName => {
      const result = {
        streetName: routeName,
        streetType: "",
        streetDirection: ""
      };
      const routeNamePieces = routeName.split(" ");
      const routeNamePiecesLength = routeNamePieces.length;
      const streetDirection = routeNamePieces[routeNamePiecesLength - 1];
      const validStreetDirection = _includesInstanceProperty(DIRECTIONS).call(DIRECTIONS, streetDirection.toLowerCase());
      const streetTypeIndex = routeNamePiecesLength - (validStreetDirection ? 2 : 1);
      const streetType = routeNamePieces[streetTypeIndex];
      result.streetDirection = validStreetDirection ? streetDirection : "";
      if (!streetTypeAbrvs[streetType.toUpperCase()]) return result;
      result.streetType = streetType;
      result.streetName = _sliceInstanceProperty(routeNamePieces).call(routeNamePieces, 0, streetTypeIndex).join(" ");
      return result;
    };
    const addressResultTypes = computed(() => props.companyAddress ? "establishment" : "geocode");
    const splitUnitNumberFromStreetNumber = (word = "") => {
      const result = {
        streetNumber: word,
        unitNumber: ""
      };
      if (!_includesInstanceProperty(word).call(word, "-")) return result;
      const splitted = word.split("-");
      if (!/^[0-9]*$/.test(splitted[0])) return result;
      result.unitNumber = splitted[0];
      result.streetNumber = splitted[1];
      return result;
    };
    const getFieldFromPlaceObjectAddressComponent = (addressComponents, field, valueName) => {
      const fieldComponent = addressComponents == null ? void 0 : _findInstanceProperty(addressComponents).call(addressComponents, component => {
        var _context;
        return _includesInstanceProperty(_context = component.types).call(_context, field);
      });
      if (!fieldComponent) return "";
      return fieldComponent[valueName] || "";
    };
    const getFullAddress = (fields, placeObject) => {
      const {
        formatted_address: formattedAddress = "",
        address_components: addressComponents,
        name: placesLine1 = ""
      } = placeObject;
      const placesProvince = getFieldFromPlaceObjectAddressComponent(addressComponents, "administrative_area_level_1", "long_name");
      const {
        street_number: placesStreetNumber = "",
        route: placesStreetName = "",
        locality: placesCity = "",
        postal_code: placesPostalCode = "",
        subpremise: placesUnitNumber = ""
      } = fields;
      const {
        streetName,
        streetType,
        streetDirection
      } = splitAddress(placesStreetName);
      const {
        unitNumber,
        streetNumber
      } = splitUnitNumberFromStreetNumber(placesStreetNumber);
      const city = isEmpty(placesCity) ? getFieldFromPlaceObjectAddressComponent(addressComponents, "administrative_area_level_3", "short_name") : placesCity;
      const companyLine2 = () => {
        return getFieldFromPlaceObjectAddressComponent(addressComponents, "subpremise", "short_name");
      };
      const companyLine1 = () => {
        const subpremise = companyLine2();
        return formattedAddress.substr(0, _indexOfInstanceProperty(formattedAddress).call(formattedAddress, `${subpremise},`)) || formattedAddress;
      };
      return {
        line1: props.companyAddress ? companyLine1() : placesLine1,
        line2: props.companyAddress ? companyLine2() : "",
        province: placesProvince,
        "postal-code": placesPostalCode,
        "street-direction": streetDirection,
        "street-name": streetName,
        "street-number": streetNumber || placesStreetNumber,
        "unit-number": unitNumber || placesUnitNumber,
        "street-type": streetType,
        city,
        "formatted-address": formattedAddress
      };
    };
    const handleValueChange = inputState => {
      if (valueSetOnMounted.value) {
        valueSetOnMounted.value = false;
        return;
      }
      emit("value-change", inputState || "");
    };
    const handleInputChange = inputState => {
      if (valueSetOnMounted.value) {
        valueSetOnMounted.value = false;
        return;
      }
      emit("input", inputState.newVal || "");
    };
    const notifyMapLocationChanged = inject("mapLocationChanged", null);
    const getPlacePhoneNumber = placeObject => {
      return new _Promise(resolve => {
        const placeId = placeObject["place_id"];
        if (placeId) {
          const wrapper = vueAutocompleteRef.value.$el;
          const request = {
            placeId: placeId,
            fields: ["name", "formatted_phone_number", "place_id", "geometry"]
          };
          const service = new google.maps.places.PlacesService(wrapper);
          service.getDetails(request, place => {
            resolve((place == null ? void 0 : place["formatted_phone_number"]) || "");
          });
        }
      });
    };
    const handleChange = (fields, placeObject, id) => {
      if (props.id !== id) return;
      internalAddressObject.value = getFullAddress(fields, placeObject);
      if (notifyMapLocationChanged && placeObject) {
        const {
          geometry
        } = placeObject;
        if (!geometry) return;
        const {
          viewport,
          location
        } = geometry;
        notifyMapLocationChanged({
          viewport,
          location
        });
      }
      nextTick(async () => {
        if (holdValueAfterAutocomplete.value) {
          const {
            name = ""
          } = placeObject;
          vueAutocompleteRef.value.update(name);
          handleValueChange(name);
        } else if (clearAfterAutocomplete.value) {
          vueAutocompleteRef.value.clear();
        }
        if (props.companyAddress) {
          const businessPhoneNumber = await getPlacePhoneNumber(placeObject);
          emit("phone-number-change", businessPhoneNumber);
        }
        emit("change", internalAddressObject.value);
      });
    };
    const autocompleteFields = ["address_components", "adr_address", "alt_id", "formatted_address", "geometry", "icon", "id", "name", "business_status", "photo", "place_id", "type", "url", "utc_offset_minutes", "vicinity"];
    return {
      handleChange,
      addressResultTypes,
      internalAddressObject,
      vueAutocompleteRef,
      handleValueChange,
      handleInputChange,
      autocompleteFields
    };
  }
});